export { onPageTransitionEnd };
import type { PageContextClient } from "vike/types";

function onPageTransitionEnd(_pageContext: PageContextClient) {
  // Analytics is non-essential: load it lazily and swallow failures (adblocker,
  // network) so a blocked module never breaks client navigation.
  void import("@/3-features/measurement/metrics")
    .then((m) => m.trackPageView())
    .catch(() => {});
}
